import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

/**
 * @component PoReportViewerComponent
 *
 * PLACEHOLDER for the in-app PO report viewer. The old MVC app linked out to
 * SSRS; that link is intentionally gone. Phoenix will replace this component's
 * internals with a server-rendered .rdlc report (MM-API will render it — the
 * reserved endpoint name is GET /V1/sof-receiving/po-report?po= — and stream
 * PDF/HTML to this component). The click handler in SofDetailComponent already
 * passes `poNumber` in, so the swap is contained to this one component.
 */
@Component({
  selector: 'app-po-report-viewer',
  templateUrl: './po-report-viewer.component.html',
  styleUrls: ['./po-report-viewer.component.css'],
})
export class PoReportViewerComponent {
  @Input() poNumber = '';

  constructor(private _modalController: ModalController) {}

  public dismiss(): void {
    this._modalController.dismiss();
  }
}
